/**
 * Created by efowler on 9/22/15.
 */

// register the interceptor as a service
frontendApp.factory('myHttpInterceptor', ['$rootScope', '$q', '$log', '$location', 'NotificationService', 'authService', function ($rootScope, $q, $log, $location, NotificationService, authService) {
  return {

    // optional method
    'response': function (response) {
      return response;
    },

    // optional method
    'responseError': function (response) {
      $log.error('Response ' + response.status + ' -> ' + response.config.url);
      const isOauthCall = /\/oauth\/token|\/oauth\/check_token/.test(response.config && response.config.url || '');

      if (response.status === 400) {
        const err = (response.data && response.data.error) || '';
        switch (err) {
          case 'unauthorized':
          case 'invalid_grant':
            $rootScope.$broadcast('event:auth-loginRequired');
        }

        if (response.data && response.data.errors) {
          _.each(response.data.errors, function (error) {
            NotificationService.addError({
              title: 'An Error Occurred',
              description: error.defaultMessage,
              buttons: '<a href="javascript:window.showChat()" class="btn btn-primary"><i class="icon-question-sign"></i> Get Help</a>'
            });
          });
        }

      } else if (response.status === 401) {
        $log.warn("Not Authorized");
        if (!isOauthCall && response.data && response.data.error == 'invalid_token') {
          var deferred = $q.defer();
          authService.append(response.config, deferred);
          //If it's unauthorized because of an invalid token, broadcast it so that a refresh can be attempted
          $rootScope.$broadcast('event:invalid-token');
          return deferred.promise;
        } else if ($rootScope.refreshingToken && !isOauthCall) {
          // A token refresh is already in progress; buffer this request so it can be
          // replayed once the refresh completes, rather than treating it as a logout.
          // isOauthCall is excluded so that a failed refresh call is not buffered.
          var deferred = $q.defer();
          authService.append(response.config, deferred);
          return deferred.promise;
        } else {
          // TODO catch what page the user is on so we can redirect back to it after they authenticate
          $rootScope.$broadcast('event:auth-loginRequired');
          $location.path('/');
        }

      } else if (response.status === 0) {

        $log.warn("Server went away");
        NotificationService.addError({
          title: 'Server Error',
          description: 'Could not communicate with the server.  Please try again in a few minutes.  If the problem persists please contact support.',
          buttons: '<a href="https://twitter.com/indexedio" class="btn btn-primary"><i class="icon-twitter"></i> Check our Twitter feed</a>'
        });

      } else {
        $rootScope.$broadcast('error');
      }
      return $q.reject(response);
    }
  };
}]);
